import { toDate } from '../to-date'

const DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/

/** Whether a string is a real calendar day (`YYYY-MM-DD`) — moment leniently overflows `2026-02-30` into March, so a day is real only when it round-trips. */
export const isCalendarDay = (day: string): boolean => DAY_PATTERN.test(day) && toDate(day).format('YYYY-MM-DD') === day
